'use client'

import { usePathname, useSelectedLayoutSegments } from 'next/navigation'
import { isMarketingPath } from './marketing-route'

/**
 * True when the page being rendered is the public marketing site, on any host.
 *
 * On meridiananesthesia.com, middleware rewrites the clean URLs (/about) to the
 * /website/* routes, but usePathname() reports the address bar ("/about"). A
 * pathname check alone therefore missed every apex page: AppShell server-
 * rendered its loading screen instead of the page, then sent the visitor to
 * /login — a 404 on the apex — and AuthProvider started session checks on the
 * public origin. The selected layout segments come from the route that
 * actually rendered, so they read "website" on every host.
 *
 * Call it only from a component rendered by the ROOT layout (AuthProvider,
 * ImpersonationBanner, AppShell): segments are relative to the caller's layout.
 */
export function useIsMarketingRoute(): boolean {
  const segments = useSelectedLayoutSegments()
  const pathname = usePathname()
  return segments[0] === 'website' || isMarketingPath(pathname)
}
